import React, { Component } from 'react';
import { Table, Row, Col, InputNumber, Button, DatePicker, message, Spin, Input, Tooltip } from 'antd';
import moment from 'moment';
import './index.scss';
import { data7_1_1 } from './data';
import imgSave from "../../saveImg";
import Auth from "../../Auth";
import Compared from "../../Compared";
import { numConvert, getJson, sum } from "@/method";
import TableText from "../../../../hr/components/TableText";
import _ from 'lodash';

const { MonthPicker } = DatePicker;
const { TextArea } = Input;

const totalIndexFooter = [11, 15, 16, 19];

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            note: { note: "" },
            loading: true,
            loadingSave: false,
            print: false,
            data1_1: [],
            lastYear: [],
            last: []
        }
    }


    componentDidMount() {
        this.getDateData(this.state.date);
    }

    computeNum = (data) => {
        const { date, last, lastYear, data1_1 } = this.state;
        const isOpenLastFill = moment(date).isBefore(moment("2022-02"));
        // 工资合计
        const totalData = ['thisy_employee_num', 'thisy_payroll_cost', 'lasty_employee_num', 'lasty_payroll_cost', 'year_thisy_employee_num', 'year_thisy_payroll_cost', 'year_lasty_employee_num', 'year_lasty_payroll_cost']

        // 填充年累计 从2022-02开始填充
        if (!isOpenLastFill) {
            //填充去年当月
            for (let i = 0; i < data.length; i++) {
                data[i].lasty_employee_num = numConvert(_.get(lastYear, `${i}.thisy_employee_num`, 0)).toFixed(2);
                data[i].lasty_average_payroll = numConvert(_.get(lastYear, `${i}.thisy_average_payroll`, 0)).toFixed(2);
                data[i].lasty_payroll_cost = numConvert(_.get(lastYear, `${i}.thisy_payroll_cost`, 0)).toFixed(2);
            }

            for (let i = 0; i < data.length; i++) {
                data[i].year_thisy_employee_num = sum([data[i].thisy_employee_num, _.get(last, `${i}.year_thisy_employee_num`, 0)]);
                data[i].year_thisy_payroll_cost = sum([data[i].thisy_payroll_cost, _.get(last, `${i}.year_thisy_payroll_cost`, 0)]);
                data[i].year_lasty_employee_num = sum([data[i].lasty_employee_num, _.get(last, `${i}.year_lasty_employee_num`, 0)]);
                data[i].year_lasty_payroll_cost = sum([data[i].lasty_payroll_cost, _.get(last, `${i}.year_lasty_payroll_cost`, 0)]);
            }
        }


        for (let index = 0; index < totalData.length; index++) {
            data[11][totalData[index]] = 0;
        }

        for (let index = 0; index < 11; index++) {
            for (let i = 0; i < totalData.length; i++) {
                data[11][totalData[i]] = (Number(data[index][totalData[i]]) + Number(data[11][totalData[i]])).toFixed(2);
                data[19][totalData[i]] = (Number(data[18][totalData[i]]) + Number(data[17][totalData[i]])).toFixed(2);
            }
        }

        // 五险一金 年终奖 其他费用 以及合计计算
        data[15].thisy_payroll_cost = data[15].lasty_payroll_cost = data[15].year_thisy_payroll_cost = data[15].year_lasty_payroll_cost = 0;
        for (let index = 12; index < 15; index++) {
            data[15].thisy_payroll_cost = (Number(data[index].thisy_payroll_cost) + Number(data[15].thisy_payroll_cost)).toFixed(2);
            data[15].lasty_payroll_cost = (Number(data[index].lasty_payroll_cost) + Number(data[15].lasty_payroll_cost)).toFixed(2);
            data[15].year_thisy_payroll_cost = (Number(data[index].year_thisy_payroll_cost) + Number(data[15].year_thisy_payroll_cost)).toFixed(2);
            data[15].year_lasty_payroll_cost = (Number(data[index].year_lasty_payroll_cost) + Number(data[15].year_lasty_payroll_cost)).toFixed(2);
        }

        data[16].thisy_payroll_cost = (Number(data[11].thisy_payroll_cost) + Number(data[15].thisy_payroll_cost)).toFixed(2);
        data[16].lasty_payroll_cost = (Number(data[11].lasty_payroll_cost) + Number(data[15].lasty_payroll_cost)).toFixed(2);
        data[16].year_thisy_payroll_cost = (Number(data[11].year_thisy_payroll_cost) + Number(data[15].year_thisy_payroll_cost)).toFixed(2);
        data[16].year_lasty_payroll_cost = (Number(data[11].year_lasty_payroll_cost) + Number(data[15].year_lasty_payroll_cost)).toFixed(2);


        // 去除浮点 保留两位小数 
        let toFixedData = {
            11: ['thisy_employee_num', 'thisy_payroll_cost', 'lasty_employee_num', 'lasty_payroll_cost', 'year_thisy_employee_num', 'year_thisy_payroll_cost', 'year_lasty_employee_num', 'year_lasty_payroll_cost'],
            15: ['thisy_payroll_cost', 'lasty_payroll_cost', 'year_thisy_payroll_cost', 'year_lasty_payroll_cost'],
            16: ['thisy_payroll_cost', 'lasty_payroll_cost', 'year_thisy_payroll_cost', 'year_lasty_payroll_cost']
        }
        for (const key in toFixedData) {
            if (toFixedData.hasOwnProperty(key)) {
                for (let index = 0; index < toFixedData[key].length; index++) {
                    data[key][toFixedData[key][index]] = data[key][toFixedData[key][index]].toFixed(2);
                }
            }
        }

        // 计算百分比  **对比**
        for (let index = 0; index < 20; index++) {
            data[index].thisy_average_payroll = Number((Number(data[index].thisy_employee_num || "0") ? Number(data[index].thisy_payroll_cost || "0") / Number(data[index].thisy_employee_num || "0") : 0).toFixed(2));
            data[index].lasty_average_payroll = Number((Number(data[index].lasty_employee_num || "0") ? Number(data[index].lasty_payroll_cost || "0") / Number(data[index].lasty_employee_num || "0") : 0).toFixed(2))
            data[index].variance_emplyee_num = Number((data[index].thisy_employee_num - data[index].lasty_employee_num).toFixed(2));
            data[index].ven_percent = Number((Number(data[index].lasty_employee_num || "0") ? Number(data[index].variance_emplyee_num || "0") / Number(data[index].lasty_employee_num || "0") : 0).toFixed(4))
            data[index].variance_average_payroll = Number((data[index].thisy_average_payroll - data[index].lasty_average_payroll).toFixed(2));
            data[index].vap_percent = Number((Number(data[index].lasty_average_payroll || "0") ? Number(data[index].variance_average_payroll || "0") / Number(data[index].lasty_average_payroll || "0") : 0).toFixed(4));
            data[index].variance_payroll = Number((data[index].thisy_payroll_cost - data[index].lasty_payroll_cost).toFixed(2));
            data[index].vp_percent = Number((Number(data[index].lasty_payroll_cost || "0") ? Number(data[index].variance_payroll || "0") / Number(data[index].lasty_payroll_cost || "0") : 0).toFixed(4))

            // 年累计
            data[index].year_thisy_average_payroll = Number((Number(data[index].year_thisy_employee_num || "0") ? Number(data[index].year_thisy_payroll_cost || "0") / Number(data[index].year_thisy_employee_num || "0") : 0).toFixed(2));
            data[index].year_lasty_average_payroll = Number((Number(data[index].year_lasty_employee_num || "0") ? Number(data[index].year_lasty_payroll_cost || "0") / Number(data[index].year_lasty_employee_num || "0") : 0).toFixed(2))
            data[index].year_variance_emplyee_num = Number((data[index].year_thisy_employee_num - data[index].year_lasty_employee_num).toFixed(2));
            data[index].year_ven_percent = Number((Number(data[index].year_lasty_employee_num || "0") ? Number(data[index].year_variance_emplyee_num || "0") / Number(data[index].year_lasty_employee_num || "0") : 0).toFixed(4))
            data[index].year_variance_average_payroll = Number((data[index].year_thisy_average_payroll - data[index].year_lasty_average_payroll).toFixed(2));
            data[index].year_vap_percent = Number((Number(data[index].year_lasty_average_payroll || "0") ? Number(data[index].year_variance_average_payroll || "0") / Number(data[index].year_lasty_average_payroll || "0") : 0).toFixed(4));
            data[index].year_variance_payroll = Number((data[index].year_thisy_payroll_cost - data[index].year_lasty_payroll_cost).toFixed(2));
        }

        data[20].thisy_payroll_cost = (getJson([8, 'actual'], data1_1) == 0 ? 0 : ((numConvert(data[19].thisy_payroll_cost) + numConvert(getJson([15, 'actual'], data1_1))) / getJson([8, 'actual'], data1_1))).toFixed(4);
        data[20].lasty_payroll_cost = (getJson([8, 'last_year'], data1_1) == 0 ? 0 : ((numConvert(data[19].lasty_payroll_cost) + numConvert(getJson([15, 'last_year'], data1_1))) / getJson([8, 'last_year'], data1_1))).toFixed(4);
        data[20].year_thisy_payroll_cost = (getJson([8, 'year_actual'], data1_1) == 0 ? 0 : ((numConvert(data[19].year_thisy_payroll_cost) + numConvert(getJson([15, 'year_actual'], data1_1))) / getJson([8, 'year_actual'], data1_1))).toFixed(4);
        data[20].year_lasty_payroll_cost = (getJson([8, 'year_last_year'], data1_1) == 0 ? 0 : ((numConvert(data[19].year_lasty_payroll_cost) + numConvert(getJson([15, 'year_last_year'], data1_1))) / getJson([8, 'year_last_year'], data1_1))).toFixed(4);

        this.setState({
            data
        });

    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;

        this.computeNum(data, { data1_1: this.state.data1_1 });
    }

    getDateData = (date) => {
        const dataBegin = JSON.stringify(data7_1_1);
        let data = JSON.parse(dataBegin);

        fetch(`/_7_1_1_all?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data.data && x.data.data.length > 0) {
                // 新增三行数据  进行兼容处理
                if (x.data.data.length > 17) {
                    data = x.data.data;
                } else {
                    data = [...x.data.data, ...JSON.parse(dataBegin).slice(JSON.parse(dataBegin).length - 4, JSON.parse(dataBegin).length)]
                }
            }

            if (!data[0].id) {
                this.setState({
                    loading: false,
                    data,
                    last: x.data.last || [],
                    lastYear: x.data.lastYear || [],
                    note: { ...x.data.note },
                    data1_1: x.data.data1_1 || []
                }, () => {
                    this.onSave();
                });
                return
            }

            this.setState({
                loading: false,
                last: x.data.last || [],
                lastYear: x.data.lastYear || [],
                note: { ...x.data.note },
                data1_1: x.data.data1_1 || []
            }, () => {
                this.computeNum(data);
            });

        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");

        let data = this.state.data.map(x => ({ ...x, year, month }));
        let dataFrom = new FormData();

        dataFrom.append('data', JSON.stringify(data));
        dataFrom.append('year', year);
        dataFrom.append('month', month);
        dataFrom.append('isNew', data[0].id ? 1 : 2);

        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }

        if (this.state.note) {
            this.onSaveNote([{ ...this.state.note, month, year }])
        }
        fetch('/addPayrollCostByLevel', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getDateData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    onSaveNote = (data) => {
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_7_1_3', headres).then(x => x.json()).then(x => {
            if (x.status != 1) {
                message.error('备注保存失败：' + x.msg);
            }

        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table7_1_1', 1.5, '7.11', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    render() {
        const { data, data1_1, date } = this.state;
        const isOpenLastFill = moment(date).isBefore(moment("2022-02"));
        const columns = [{
            title: 'Level 职级',
            dataIndex: 'name',
            key: 'name',
            align: "center",
            fixed: "left",
            width: 500,
            render: (text, record, index) => {
                const props = { text, index, type: 'text', name: "name", onChange: this.onChange, totalIndex: totalIndexFooter };
                return (
                    // <div className={`table-padding ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
                    //     {text}
                    // </div>
                    <TableText data={props} />
                )
            }
        }, {
            title: 'MTD 月累计',
            align: "center",
            width: 1800,
            children: [{
                align: "center",
                title: 'MTD Actual - This Year 本年当月实际数',
                width: 450,
                children: [{
                    title: <div>No. of Employee<br />员工数</div>,
                    dataIndex: 'thisy_employee_num',
                    key: 'thisy_employee_num',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['MTD 月累计', 'MTD Actual - This Year 本年当月实际数', 'No. of Employee 员工数'];
                        if (index == 20) {
                            return (
                                <div className={`table-padding`} >
                                    -
                                </div>
                            )
                        }
                        if (index >= 0 && index <= 10) {
                            return (
                                <Compared data={{ index, key: 'thisy_employee_num', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={text}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('thisy_employee_num', value, index)
                                            }}

                                        />
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'thisy_employee_num', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'number' }}>
                                    <div className={`table-padding ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''}`}>
                                        {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }, {
                    title: <div>Average Payroll<br />平均工资</div>,
                    dataIndex: 'thisy_average_payroll',
                    key: 'thisy_average_payroll',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['MTD 月累计', 'MTD Actual - This Year 本年当月实际数', 'Average Payroll 平均工资'];
                        if (index == 20) {
                            return (
                                <div className={`table-padding`} >
                                    -
                                </div>
                            )
                        }
                        return (
                            <Compared data={{ index, key: 'thisy_average_payroll', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''}`} >
                                    {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>Payroll Cost<br />工资成本</div>,
                    dataIndex: 'thisy_payroll_cost',
                    key: 'thisy_payroll_cost',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['MTD 月累计', 'MTD Actual - This Year 本年当月实际数', 'Payroll Cost 工资成本'];
                        if (index == 20) {
                            return (
                                <div className={`table-padding`} >
                                    <div className={`table-padding ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''}`} >
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(2) + '%'})</span> : (text * 100).toFixed(2) + '%'}
                                    </div>
                                </div>
                            )
                        }
                        if ([11, 15, 16, 19, 20].includes(index)) {
                            return (
                                <Compared data={{ index, key: 'thisy_payroll_cost', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'number' }}>
                                    <Tooltip title={index == 16 && ~~text != ~~_.get(data1_1, '[15].actual') ? '该项设置ES 1.1的数据不一致，请检查' : ''}>
                                        <div className={` table-padding  ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''} ${index == 16 && ~~text != ~~_.get(data1_1, '[15].actual') ? 'yellowWaring' : ''} `} >
                                            {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        </div>
                                    </Tooltip>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'thisy_payroll_cost', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={text}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('thisy_payroll_cost', value, index)
                                            }}

                                        />
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }]
            }, {
                align: "center",
                title: 'MTD Actual - Last Year 去年当月实际数',
                width: 450,
                children: [{
                    title: <div>No. of Employee<br />员工数</div>,
                    dataIndex: 'lasty_employee_num',
                    key: 'lasty_employee_num',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['MTD 月累计', 'MTD Actual - Last Year 去年当月实际数', 'No. of Employe 员工数'];
                        if (index == 20) {
                            return (
                                <div className={`table-padding`} >
                                    -
                                </div>
                            )
                        }
                        if (index >= 0 && index <= 10 && isOpenLastFill) {
                            return (
                                <Compared data={{ index, key: 'lasty_employee_num', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={text}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('lasty_employee_num', value, index)
                                            }}

                                        />
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'lasty_employee_num', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'number' }}>
                                    <div className={`table-padding ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''}`} >
                                        {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }, {
                    title: <div>Average Payroll<br />平均工资</div>,
                    dataIndex: 'lasty_average_payroll',
                    key: 'lasty_average_payroll',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['MTD 月累计', 'MTD Actual - Last Year 去年当月实际数', 'Average Payroll 平均工资'];
                        if (index == 20) {
                            return (
                                <div className={`table-padding`} >
                                    -
                                </div>
                            )
                        }
                        return (
                            <Compared data={{ index, key: 'lasty_average_payroll', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''}`} >
                                    {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>Payroll Cost<br />工资成本</div>,
                    dataIndex: 'lasty_payroll_cost',
                    key: 'lasty_payroll_cost',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['MTD 月累计', 'MTD Actual - Last Year 去年当月实际数', 'Payroll Cost 工资成本'];
                        if (index == 20) {
                            return (
                                <div className={`table-padding`} >
                                    <div className={`table-padding ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''}`} >
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(2) + '%'})</span> : (text * 100).toFixed(2) + '%'}
                                    </div>
                                </div>
                            )
                        }

                        if ([11, 15, 16, 19, 20].includes(index) || !isOpenLastFill) {
                            return (
                                <Compared data={{ index, key: 'lasty_payroll_cost', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'number' }}>
                                    <div className={`table-padding ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''}`} >
                                        {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'lasty_payroll_cost', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={text}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('lasty_payroll_cost', value, index)
                                            }}

                                        />
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }]
            }, {
                align: "center",
                title: 'MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年',
                width: 900,
                children: [{
                    title: <div>No. of Employee<br />员工数</div>,
                    dataIndex: 'variance_emplyee_num',
                    key: 'variance_emplyee_num',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['MTD 月累计', 'MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年', 'No. of Employee 员工数'];
                        if (index == 20) {
                            return (
                                <div className={`table-padding`} >
                                    -
                                </div>
                            )
                        }
                        return (
                            <Compared data={{ index, key: 'variance_emplyee_num', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'number' }}>
                                <div className={`table-padding  ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'ven_percent',
                    key: 'ven_percent',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['MTD 月累计', 'MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年', '% 百分比'];
                        if (index == 20) {
                            return (
                                <div className={`table-padding`} >
                                    -
                                </div>
                            )
                        }
                        return (
                            <Compared data={{ index, key: 'ven_percent', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'percent' }}>
                                <div className={`table-padding ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(2) + '%'})</span> : (text * 100).toFixed(2) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>Average Payroll<br />平均工资</div>,
                    dataIndex: 'variance_average_payroll',
                    key: 'variance_average_payroll',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['MTD 月累计', 'MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年', 'Average Payroll 平均工资'];
                        if (index == 20) {
                            return (
                                <div className={`table-padding`} >
                                    -
                                </div>
                            )
                        }
                        return (
                            <Compared data={{ index, key: 'variance_average_payroll', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'vap_percent',
                    align: "center",
                    key: 'vap_percent',
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['MTD 月累计', 'MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年', '% 百分比'];
                        if (index == 20) {
                            return (
                                <div className={`table-padding`} >
                                    -
                                </div>
                            )
                        }
                        return (
                            <Compared data={{ index, key: 'vap_percent', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'percent' }}>
                                <div className={`table-padding ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(2) + '%'})</span> : (text * 100).toFixed(2) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>Payroll Cost<br />工资成本</div>,
                    dataIndex: 'variance_payroll',
                    key: 'variance_payroll',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['MTD 月累计', 'MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年', 'Payroll Cost 工资成本'];
                        if (index == 20) {
                            return (
                                <div className={`table-padding`} >
                                    <div className={`table-padding ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''}`} >
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(2) + '%'})</span> : (text * 100).toFixed(2) + '%'}
                                    </div>
                                </div>
                            )
                        }
                        return (
                            <Compared data={{ index, key: 'variance_payroll', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'vp_percent',
                    key: 'vp_percent',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['MTD 月累计', 'MTD Variance - This Year vs. Last Year 当月差异 - 今年对比去年', '% 百分比'];
                        if (index == 20) {
                            return (
                                <div className={`table-padding`} >
                                    -
                                </div>
                            )
                        }
                        return (
                            <Compared data={{ index, key: 'vp_percent', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'percent' }}>
                                <div className={`table-padding  ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(2) + '%'})</span> : (text * 100).toFixed(2) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                }]
            },],
        }, {
            title: 'YTD 年累计',
            align: "center",
            width: 1650,
            children: [{
                align: "center",
                title: 'YTD Actual - This Year 年累计实际 - 今年',
                width: 450,
                children: [{
                    title: <div>No. of Employee<br />员工数</div>,
                    dataIndex: 'year_thisy_employee_num',
                    key: 'year_thisy_employee_num',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Actual - This Year 年累计实际 - 今年', 'No. of Employee 员工数'];
                        if (index == 20) {
                            return (
                                <div className={`table-padding`} >
                                    -
                                </div>
                            )
                        }
                        if (index >= 0 && index <= 10 && isOpenLastFill) {
                            return (
                                <Compared data={{ index, key: 'year_thisy_employee_num', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={text}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('year_thisy_employee_num', value, index)
                                            }}
                                            onCha
                                        />
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'year_thisy_employee_num', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'number' }}>
                                    <div className={`table-padding ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''}`}>
                                        {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }, {
                    title: <div>Average Payroll<br />平均工资</div>,
                    dataIndex: 'year_thisy_average_payroll',
                    key: 'year_thisy_average_payroll',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Actual - This Year 年累计实际 - 今年', 'Average Payroll 平均工资'];
                        if (index == 20) {
                            return (
                                <div className={`table-padding`} >
                                    -
                                </div>
                            )
                        }
                        return (
                            <Compared data={{ index, key: 'year_thisy_average_payroll', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''}`} >
                                    {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>Payroll Cost<br />工资成本</div>,
                    dataIndex: 'year_thisy_payroll_cost',
                    key: 'year_thisy_payroll_cost',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Actual - This Year 年累计实际 - 今年', 'Payroll Cost 工资成本'];
                        if (index == 20) {
                            return (
                                <div className={`table-padding`} >
                                    <div className={`table-padding ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''}`} >
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(2) + '%'})</span> : (text * 100).toFixed(2) + '%'}
                                    </div>
                                </div>
                            )
                        }
                        if ([11, 15, 16, 19, 20].includes(index)) {
                            return (
                                <Compared data={{ index, key: 'year_thisy_payroll_cost', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'number' }}>
                                    <Tooltip title={index == 16 && ~~text != ~~_.get(data1_1, '[15].year_actual') ? '该项设置ES 1.1的数据不一致，请检查' : ''}>
                                        <div className={`table-padding ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''} ${index == 16 && ~~text != ~~_.get(data1_1, '[15].year_actual') ? 'yellowWaring' : ''}`} >
                                            {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        </div>
                                    </Tooltip>

                                </Compared>
                            )
                        } else if (isOpenLastFill) {
                            return (
                                <Compared data={{ index, key: 'year_thisy_payroll_cost', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={text}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('year_thisy_payroll_cost', value, index)
                                            }}
                                        />
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'year_thisy_payroll_cost', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'number' }}>
                                    <div className={`table-padding ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''}`}>
                                        {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }]
            }, {
                align: "center",
                title: 'YTD Actual - Last Year 年累计实际 - 去年',
                width: 450,
                children: [{
                    title: <div>No. of Employee<br />员工数</div>,
                    dataIndex: 'year_lasty_employee_num',
                    key: 'year_lasty_employee_num',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Actual - Last Year 年累计实际 - 去年', 'No. of Employee 员工数'];
                        if (index == 20) {
                            return (
                                <div className={`table-padding`} >
                                    -
                                </div>
                            )
                        }
                        if (index >= 0 && index <= 10 && isOpenLastFill) {
                            return (
                                <Compared data={{ index, key: 'year_lasty_employee_num', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={text}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('year_lasty_employee_num', value, index)
                                            }}
                                        />
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'year_lasty_employee_num', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'number' }}>
                                    <div className={`table-padding ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''}`} >
                                        {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }, {
                    title: <div>Average Payroll<br />平均工资</div>,
                    dataIndex: 'year_lasty_average_payroll',
                    key: 'year_lasty_average_payroll',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Actual - Last Year 年累计实际 - 去年', 'Average Payroll 平均工资'];
                        if (index == 20) {
                            return (
                                <div className={`table-padding`} >
                                    -
                                </div>
                            )
                        }
                        return (
                            <Compared data={{ index, key: 'year_lasty_average_payroll', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''}`} >
                                    {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>Payroll Cost<br />工资成本</div>,
                    dataIndex: 'year_lasty_payroll_cost',
                    key: 'year_lasty_payroll_cost',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Actual - Last Year 年累计实际 - 去年', 'Payroll Cost 工资成本'];
                        if (index == 20) {
                            return (
                                <div className={`table-padding`} >
                                    <div className={`table-padding ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''}`} >
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(2) + '%'})</span> : (text * 100).toFixed(2) + '%'}
                                    </div>
                                </div>
                            )
                        }
                        if ([11, 15, 16, 19, 20].includes(index)) {
                            return (
                                <Compared data={{ index, key: 'year_lasty_payroll_cost', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'number' }}>
                                    <div className={`table-padding ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''}`} >
                                        {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>
                            )
                        } else if (isOpenLastFill) {
                            return (
                                <Compared data={{ index, key: 'year_lasty_payroll_cost', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'number' }}>
                                    <div className="table-padding table-color-number">
                                        <InputNumber
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            precision={2}
                                            className="table_numInput"
                                            defaultValue={text}
                                            onBlur={(e) => {
                                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                                value = Number(value.toFixed(2));
                                                this.onChange('year_lasty_payroll_cost', value, index)
                                            }}
                                        />
                                    </div>
                                </Compared>
                            )
                        } else {
                            return (
                                <Compared data={{ index, key: 'year_lasty_payroll_cost', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'number' }}>
                                    <div className={`table-padding ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''}`} >
                                        {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </div>
                                </Compared>
                            )
                        }

                    }
                }]
            }, {
                align: "center",
                title: 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年',
                width: 750,
                children: [{
                    title: <div>No. of Employee<br />员工数</div>,
                    dataIndex: 'year_variance_emplyee_num',
                    key: 'year_variance_emplyee_num',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', 'No. of Employee 员工数'];
                        if (index == 20) {
                            return (
                                <div className={`table-padding`} >
                                    -
                                </div>
                            )
                        }
                        return (
                            <Compared data={{ index, key: 'year_variance_emplyee_num', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'number' }}>
                                <div className={`table-padding  ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'year_ven_percent',
                    key: 'year_ven_percent',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', '% 百分比'];
                        if (index == 20) {
                            return (
                                <div className={`table-padding`} >
                                    -
                                </div>
                            )
                        }

                        return (
                            <Compared data={{ index, key: 'year_ven_percent', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'percent' }}>
                                <div className={`table-padding ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(2) + '%'})</span> : (text * 100).toFixed(2) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>Average Payroll<br />平均工资</div>,
                    dataIndex: 'year_variance_average_payroll',
                    key: 'year_variance_average_payroll',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', 'Average Payroll 平均工资'];
                        if (index == 20) {
                            return (
                                <div className={`table-padding`} >
                                    <div className={`table-padding ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''}`} >
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(2) + '%'})</span> : (text * 100).toFixed(2) + '%'}
                                    </div>
                                </div>
                            )
                        }
                        return (
                            <Compared data={{ index, key: 'year_variance_average_payroll', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: '% 百分比',
                    dataIndex: 'year_vap_percent',
                    align: "center",
                    key: 'year_vap_percent',
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', '% 百分比'];
                        if (index == 20) {
                            return (
                                <div className={`table-padding`} >
                                    -
                                </div>
                            )
                        }
                        return (
                            <Compared data={{ index, key: 'year_vap_percent', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'percent' }}>
                                <div className={`table-padding ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(2) + '%'})</span> : (text * 100).toFixed(2) + '%'}
                                </div>
                            </Compared>
                        )
                    }
                }, {
                    title: <div>Payroll Cost<br />工资成本</div>,
                    dataIndex: 'year_variance_payroll',
                    key: 'year_variance_payroll',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const title = ['YTD 年累计', 'YTD Variance - This Year vs. Last Year 年累计差异 - 今年对比去年', 'Payroll Cost 工资成本 '];
                        if (index == 20) {
                            return (
                                <div className={`table-padding`} >
                                    <div className={`table-padding ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''}`} >
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(2) + '%'})</span> : (text * 100).toFixed(2) + '%'}
                                    </div>
                                </div>
                            )
                        }
                        return (
                            <Compared data={{ index, key: 'year_variance_payroll', title, sqlName: "payroll_cost_by_level", name: record.name, type: 'number' }}>
                                <div className={`table-padding ${[11, 15, 16, 19].includes(index) ? 'table-color-footer' : ''}`} >
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }
                }
                    // , {
                    //     title: '% 百分比',
                    //     dataIndex: 'year_vp_percent',
                    //     key: 'year_vp_percent',
                    //     align: "center",
                    //     render: (text, record, index) => {
                    //         return (
                    //             <div className={`table-padding  ${[11,15,16,19].includes(index) ? 'table-color-footer' : ''}`} >
                    //                 {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(2) + '%'})</span> : (text * 100).toFixed(2) + '%'}
                    //             </div>
                    //         )
                    //     }
                    // }
                ]
            },],
        }];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1">
                    <Row className="title" id="table7_1_1" style={{ width: this.state.print ? 4150 : 'auto' }}>
                        <Row>7.1.1 Payroll Cost By Level 薪酬按照职级分析</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        note: { note: "" },
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }}
                            />
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            pagination={false}
                            className="content"
                            style={{ width: this.state.print ? 3950 : 'auto' }}
                            scroll={this.state.print ? {} : { x: 3950, y: 500 }}
                            rowKey={(record, index) => index}
                        />
                        <Row style={{ margin: "20px 0", fontSize: 16 }}>
                            <Row>Please critique if variance above +/- 5% 若差异数超过上下百分之五则需做出书面解释</Row>
                            <Row style={{ margin: "10px 0" }}>Remarks: To include any salary adjustment for B2 and above positions for current month 备注：若本月有任何B2级以上人员薪资调整，必须在如下表格中注明原因</Row>
                            {this.state.data.length > 0 ? <TextArea
                                rows={4}
                                placeholder="请输入备注！"
                                defaultValue={this.state.note.note}
                                onBlur={(e) => {
                                    this.setState({
                                        note: { ...this.state.note, note: e.target.value }
                                    });
                                }}
                            /> : null}
                        </Row>
                    </Row>
                    <Auth loading={this.state.loading} auth="edit_7_1">
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Row>
                    </Auth>

                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/7-HumanResourcesAnalysis/7-1TotalPayrollCostAnalysis/7-1-1PayrollCostByLevel.js